module.exports = __webpack_public_path__ + "7d088296/img/verified-icon.f93bbc14.svg";